import { Component, OnInit } from "@angular/core";

import { BehaviorSubject } from "rxjs";



import { BaseControlComponent } from "../base-control/base-control.component";
import { PdfGeneratorService } from "../../../common/services/pdf-generator.service";
import { LoaderService } from "../../../common/services/loader.service";
import { ContextInteractionService } from "../../services/context-interaction.service";
import { ReportTemplate } from "../../../models/comodel/mergefieldsmodel.model";
import { SignerType } from "../../../admin/models/contact.model";


@Component({
    selector: "pdf-generator",
    templateUrl: "./pdf-generator.component.html",
    styleUrls: ["./pdf-generator.component.scss"],
    standalone: false
})

export class PdfGeneratorComponent extends BaseControlComponent implements OnInit  {
    static componentName = "PdfGeneratorComponent";
    isLoading$ = new BehaviorSubject(false);
    get reportTemplate(): ReportTemplate {
        if (this.componentData.config && this.componentData.config.template && this.componentData.config.template.id !== "-1") {
                return this.componentData.config.template;
        }
        return {
            id: "-1", name: "No Report Configured", reportFlowId: "", reportContextValues: [],
            allowedSignerTypes: [], typeCode: "", onBaseDocumentGroupName: "", onBaseDocumentTypeName: "", categoryCode: ""
        } as ReportTemplate;
    }

    get reportName(): string {
        return this.reportTemplate.name;
    }

    useEmbed: boolean = true;
    reportData: Uint8Array;

    constructor(public rptService: PdfGeneratorService, public loader: LoaderService, public readonly contextService: ContextInteractionService) {
        super(contextService);
    }

    ngOnInit() {
        super.ngOnInit();
        if (!this.isEdit && this.reportTemplate.id !== "-1") {
            this.isLoading$.next(true);
            this.loader.toggleLoader(true);
            const flowId = this.flowComponent.workflow.id;
            this.rptService.generate(flowId, this.componentData.key).subscribe((data) => {
                    this.isLoading$.next(false);
                    this.reportData = data;   
                    this.loader.toggleLoader(false);
                },
                (error) => {
                    console.log(error);
                    this.loader.toggleLoader(false);
                });
        }
    }

    download() {
		if (this.isEdit || !this.isLoading$) return;
		const safeBytes = new Uint8Array(this.reportData);
        const blob = new Blob([safeBytes], { type: "application/pdf" });
        const fileName = `${this.flowComponent.workflow.name}.pdf`;
		var url = URL.createObjectURL(blob);
		const link = document.createElement("a");
		link.href = url;
		link.download = fileName;
		link.click();
		setTimeout(() => {
			URL.revokeObjectURL(url);
		});
    }

  
}